'use client';

import Script from 'next/script';

const GTM_ID = 'GTM-T8DL3T5L';

// Read consent cookie directly — this runs inline before GTM loads
function getConsentFromCookie(): 'granted' | 'denied' {
  if (typeof document === 'undefined') return 'denied';
  const match = document.cookie
    .split('; ')
    .find((row) => row.startsWith('rm_consent='));
  if (!match) return 'denied';
  try {
    const parsed = JSON.parse(decodeURIComponent(match.split('=')[1]));
    return parsed?.categories?.analytics === true ? 'granted' : 'denied';
  } catch {
    return 'denied';
  }
}

export const GTMScript = () => {
  const analyticsConsent = getConsentFromCookie();

  return (
    <Script
      id="gtm-script"
      strategy="afterInteractive"
      dangerouslySetInnerHTML={{
        __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){window.dataLayer.push(arguments);}
          gtag('consent', 'default', {
            analytics_storage: '${analyticsConsent}',
            functionality_storage: 'granted',
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied',
            wait_for_update: 500
          });

          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${GTM_ID}');
        `,
      }}
    />
  );
};
